package at.theatervogelweide.admin.web

import at.theatervogelweide.admin.contract.AdminError
import at.theatervogelweide.admin.contract.AdminResult
import kotlinx.coroutines.CancellationException

/**
 * Runs one RPC call of a screen: a lost connection or an exception from the server becomes [AdminError.internal], so the
 * screen shows its usual error; a cancelled effect stays cancelled. kotlinx.rpc rethrows a server's exception as a
 * `Throwable` that isn't an `Exception` on Kotlin/JS, and one that escapes a `LaunchedEffect` stops the whole app (#59).
 */
suspend fun <T> rpcCall(block: suspend () -> AdminResult<T>): AdminResult<T> =
    try {
        block()
    } catch (exception: CancellationException) {
        throw exception
    } catch (exception: Throwable) {
        console.error("An RPC call failed", exception)
        AdminResult.Failure(AdminError.internal())
    }
